import React, { useState } from 'react';
import ClarityLogo from '../assets/images/clarity-logo.png';




const Header = () => {
    const [username, setUsername] = useState(sessionStorage.getItem('username'));
    const [userFirstname, setFirstName] = useState(sessionStorage.getItem('firstname'));
    const [decodedToken, setDecodedToken] = useState(sessionStorage.getItem('decodedToken'));
    const [bearerToken, setBearerToken] = useState(sessionStorage.getItem('bearerToken'));


    return (
        <header id="page-topbar">
            <nav className="navbar navbar-expand-lg navbar-light navbar-custom">
                <div className="container-fluid">
                    <a className="navbar-brand" href="#">
                        <img src={ClarityLogo} alt="Bootstrap" height="45" />
                    </a>
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">

                        {username && (
                            <ul className="navbar-nav ms-auto">
                                <li className="nav-item">
                                    <a href='#'
                                        className="nav-link"
                                        role="button"
                                    >
                                        <span
                                            className="d-xl-inline-block me-5"
                                        >
                                            Welcome, {userFirstname}
                                        </span>
                                    </a>


                                </li>
                                <li className="nav-item">


                                    <a href='#'
                                        className="nav-link"
                                        role="button"
                                    >
                                        <span
                                            className="d-xl-inline-block me-5" id="headerHome"
                                        >
                                            Logout
                                        </span>
                                    </a>
                                </li>
                            </ul>
                        )}


                    </div>
                </div>
            </nav>
        </header>
    );
};

export default Header;
